import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_8 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Filter ")
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_add_categories"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Add Categories ")
const _hoisted_14 = { class: "card-body pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdwon = _resolveComponent("FilterDropdwon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_addCategoriesModal = _resolveComponent("addCategoriesModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14",
              placeholder: "Search Categories"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _hoisted_10
            ]),
            _createVNode(_component_FilterDropdwon, {
              tableData: _ctx.selectData,
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["tableData", "onSubmitFilter", "onResetFilter"]),
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _hoisted_13
            ])
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          "row-key": "id",
          lazy: "",
          load: _ctx.load,
          "tree-props": {
          children: 'category_items',
          hasChildren: 'has_children',
        }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: i,
                label: cell.name,
                align: cell.key == 'actions' ? 'right' : 'left',
                width: cell.key == 'actions' ? '100px' : ''
              }, _createSlots({ _: 2 }, [
                (cell.key == 'name')
                  ? {
                      name: "default",
                      fn: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.name + " (ID: " + scope.row.id + ") "), 1)
                      ])
                    }
                  : (cell.key == 'actions')
                    ? {
                        name: "default",
                        fn: _withCtx((scope) => [
                          _createVNode(_component_router_link, {
                            to: '/catalog/categories/' + scope.row.id + '/information',
                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      }
                    : (cell.key == 'status')
                      ? {
                          name: "default",
                          fn: _withCtx((scope) => [
                            (scope.row[cell.key] == 10)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "badge badge-light-success"
                                }, "Activated"))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "badge badge-light-danger"
                                }, "Deactivated"))
                          ])
                        }
                      : {
                          name: "default",
                          fn: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(scope.row[cell.key]), 1)
                          ])
                        }
              ]), 1032, ["label", "align", "width"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["data", "load"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_addCategoriesModal, {
      onUpdateList: _ctx.UpdatesList,
      tableData: _ctx.selectData
    }, null, 8, ["onUpdateList", "tableData"])
  ], 64))
}